import React from "react";

// 8x8 bitmaps, rendered as crisp square blocks (no anti-aliasing) so they
// read as genuine pixel-art icons instead of relying on the OS emoji font.
const PATTERNS = {
  globe: [
    "00111100",
    "01111110",
    "11000011",
    "11000011",
    "11000011",
    "11000011",
    "01111110",
    "00111100",
  ],
  calendar: [
    "11111111",
    "10000001",
    "11111111",
    "10001001",
    "10000001",
    "10001001",
    "10000001",
    "11111111",
  ],
  film: [
    "11111111",
    "10011001",
    "11111111",
    "10011001",
    "11111111",
    "10011001",
    "11111111",
    "10011001",
  ],
};

function PixelIcon({ type, color = "currentColor", size = 20, className }) {
  const rows = PATTERNS[type] || PATTERNS.globe;
  const cell = 2;
  const dim = rows.length * cell;

  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox={`0 0 ${dim} ${dim}`}
      shapeRendering="crispEdges"
      aria-hidden="true"
    >
      {rows.map((row, y) =>
        row
          .split("")
          .map((bit, x) =>
            bit === "1" ? (
              <rect
                key={`${x}-${y}`}
                x={x * cell}
                y={y * cell}
                width={cell}
                height={cell}
                fill={color}
              />
            ) : null,
          ),
      )}
    </svg>
  );
}

export default PixelIcon;
